import React, { Component } from "react";
import { Header, Grid } from "semantic-ui-react";
import { ChangeData } from "./style.js";

export default class OverviewTableRow extends Component {
  render() {
    const { row, compact, showHospitalDomainScores } = this.props;
    const { domain, score, benchmarkPercentile, benchmarkPercentileOrdinal, unit, prevYear, overall } = row;
    const change = unit
      ? parseInt(unit.score) - parseInt(prevYear && prevYear.score)
      : parseInt(score) - parseInt(prevYear && prevYear.score);
    return (
      <Grid.Row className={this.props.compact ? "compact" : ""}>
        <Grid.Column textAlign="left">
          <Header as="h4">
            {domain === "Learning Environment" ? "Improvement Readiness" : domain}
            {domain.match(/.*Burnout.*/) && <sup>‡</sup>}
          </Header>
        </Grid.Column>
        <Grid.Column>
          {unit ? unit.score : score}%
          {prevYear &&
            !isNaN(change) && (
              <ChangeData
                className={`${change === 0 ? "no-change" : change > 0 ? "up" : "down"} ${unit || overall ? "unit-report" : ""}`}
              >
                {Math.abs(change)}%
                {change > 0 ? " ↑" : change < 0 ? " ↓" : ""}
              </ChangeData>
            )}
        </Grid.Column>
        {unit && showHospitalDomainScores && <Grid.Column>{score}%</Grid.Column>}
        {overall && <Grid.Column>{overall}%</Grid.Column>}
        {!unit && (
          <Grid.Column>
            {benchmarkPercentile}
            {benchmarkPercentileOrdinal}
          </Grid.Column>
        )}
        {unit && (
          <Grid.Column>
            {unit.benchmarkPercentile}
            {unit.benchmarkPercentileOrdinal}
          </Grid.Column>
        )}
      </Grid.Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/DomainScores/components/OverviewTableRow/index.jsx